<template>
  <div>
    <md-dialog :md-active.sync="state.showWarning" :fullscreen="false">
      <md-dialog-title>
        <md-icon>warning</md-icon>
        Warning
      </md-dialog-title>
      
      <md-dialog-content>
        The Authoring Tool is intended to be used on Google Chrome. Using it on other browsers may cause issues with functionality. Please reopen in Google Chrome.
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary md-raised" @click="state.showWarning = false">Okay</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import is from 'is_js';

export default {
  name: 'browser-compatibility-warning',
  data: () => ({
    state: {
      showWarning: !is.chrome(),
    },
  }),
};
</script>

<style scoped>
.md-dialog {
  max-width: 600px;
  height: auto;
}

.md-icon {
  color: #face14 !important;
}
</style>